var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_angular_112_288)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_112_288",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5 52.25) rotate(21.1364) scale(51.9982 207.993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE8B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342016,
    stopColor: "#7C53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64386,
    stopColor: "#F796FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47C4EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientCircle);
export default __webpack_public_path__ + "static/media/gradient-circle.e47cacd603d34459767d4f18f442fda6.svg";
export { ForwardRef as ReactComponent };